<template>
  <el-container>
    <el-main style="padding: 0; display: flex">
      <div style="width: 550px; padding: 20px">
        <span>生产工单绑定条码</span>
        <el-divider/>
        <el-form
            ref="form"
            :loading="loading"
            style="width: 550px"
            :model="formData"
            class="form"
            label-width="90px"
            @submit.native.prevent>
          <el-form-item label="生产订单号">
            <el-input
                ref="billNoInput"
                v-model="formData.billNo"
                placeholder="请输入生产订单号"
                size="mini"
                clearable
                @keyup.enter.native.stop="fetchOrderInfo"/>
          </el-form-item>
          <el-form-item label="绑定类型">
            <el-select v-model="formData.type" placeholder="请选择绑定类型">
              <el-option :value="0" label="绑定不过站"/>
              <el-option :value="1" label="绑定过站"/>
            </el-select>
          </el-form-item>
          <el-form-item label="原订单报工">
            <el-select v-model="formData.confirmFlag" placeholder="请选择">
              <el-option :value="0" label="不报工"/>
              <el-option :value="1" label="报工"/>
            </el-select>
          </el-form-item>
          <el-form-item label="工单数量">
            <el-input v-model="formData.orderLength" placeholder="数量" size="mini" :disabled="true"/>
          </el-form-item>
          <el-form-item label="已绑定数量">
            <el-input v-model="formData.bindedLength" placeholder="数量" size="mini" :disabled="true"/>
          </el-form-item>
          <el-form-item label="剩余绑定数量">
            <el-input v-model="formData.leftLength" placeholder="数量" size="mini" :disabled="true"/>
          </el-form-item>
        </el-form>
        <span>扫描记录</span>
        <el-divider/>
        <el-table
            style="width: 550px"
            border
            stripe
            :data="scanList"
            :row-style="{ height: '40px' }">
          <el-table-column prop="index" align="center" label="序号" width="60"/>
          <el-table-column prop="serialNumber" align="center" label="序列号">
            <template slot-scope="scope">
              <el-input
                  :ref="`serialNumberInputs${scope.$index}`"
                  v-model="scope.row.serialNumber"
                  placeholder="请输入序列号"
                  size="mini"
                  @keyup.enter.native.stop="focusNextInput(scope.$index, scope.row)"/>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 20px">
          <el-upload
              action=""
              :http-request="importFile"
              :show-file-list="false"
              style="float: left; margin-right: 4px;">
            <el-button type="primary" :loading="importLoading">导入模板</el-button>
          </el-upload>
          <el-button type="primary" :loading="exportLoading" size="mini" @click="exportFile">导出文件</el-button>
          <el-button type="danger" size="mini" :disabled="!isBinded" @click="clearBarcode"> 清空 </el-button>
          <el-button
              type="primary"
              :loading="loading"
              size="mini"
              :disabled="isBinded"
              @click="bindBarcode">
            绑定
          </el-button>
        </div>
        <export-txt-config
            storage-key-prefix="productionOrderBindBarcode"
            :file-name="exportFileName"
            @update:fileName="(newVal) => exportFileName = newVal"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import ExportTxtConfig from "@/components/ExportTxtConfig.vue";
  export default {
    name: "ProductionOrderBindBarcode",
    components: {
      ExportTxtConfig,
    },
    data() {
      return {
        loading: false,
        importLoading: false,
        exportLoading: false,
        exportFileName: "production_order_bind", // 默认导出文件名
        formData: {
          billNo: "",
          orderLength: "",
          bindedLength: "",
          leftLength: "",
          type: 0,
          confirmFlag: 0,
        },
        scanList: [],
        barcodeLength: null, // 第一个条码的长度作为基准
        isBinded: false, // 绑定状态
      };
    },
    methods: {
      // 获取订单信息
      fetchOrderInfo() {
        if (!this.formData.billNo) {
          this.$message.warning("请输入生产订单号");
          return;
        }

        this.loading = true;
        // 这里需要替换为实际的接口地址
        this.$http.get("basic", `sapProductionOrders/selectBingInfo/${this.formData.billNo}`)
          .then(response => {
            this.loading = false;
            if (response.success) {
              const data = response.data;
              this.formData.orderLength = data.orderNum || 0;
              this.formData.bindedLength = data.bindedNum;
              this.formData.leftLength = data.leftNum;
              this.barcodeLength = null; // 重置条码长度基准
              this.generateScanList(this.formData.leftLength);
              // 自动聚焦第一个输入框
              this.$nextTick(() => {
                if (this.$refs.serialNumberInputs0) {
                  this.$refs.serialNumberInputs0.focus();
                }
              });
            }
          })
          .catch(error => {
            this.loading = false;
            this.$message.error("获取订单信息失败");
            console.error("获取订单信息失败:", error);
          });
      },

      // 生成扫描列表
      generateScanList(length) {
        this.scanList = [];
        for (let i = 0; i < length; i++) {
          this.scanList.push({
            index: i + 1,
            serialNumber: "",
          });
        }
      },

      // 聚焦到下一行输入框
      focusNextInput(currentIndex, row) {
        if (currentIndex === 0) {
          if (row.serialNumber) {
            this.$playScanSuccess(); // 播放扫描成功音效
            if (currentIndex < this.scanList.length - 1) {
              if (this.$refs[`serialNumberInputs${currentIndex + 1}`]) {
                this.$refs[`serialNumberInputs${currentIndex + 1}`].focus();
              }
            }
          } else {
            this.$playScanFailure();
          }
        } else {
          // 校验是否重复 检查当前条码长度是否与基准一致
          if (!this.checkDuplicateBarcode(row.serialNumber, currentIndex) || !this.checkBarcodeLengthConsistency(row.serialNumber, currentIndex)) return;

          this.$playScanSuccess(); // 播放扫描成功音效
          if (currentIndex < this.scanList.length - 1) {
            if (this.$refs[`serialNumberInputs${currentIndex + 1}`]) {
              this.$refs[`serialNumberInputs${currentIndex + 1}`].focus();
            }
          }
        }
      },

      // 校验当前输入条码与已知条码是否重复
      checkDuplicateBarcode(currentBarcode, index) {
        const serialNumberList = this.scanList.filter((item, ind) => ind !== index && !!item.serialNumber).map(item => item.serialNumber);
        if (serialNumberList.includes(currentBarcode)) {
          this.$message.warning("当前条码已存在，请重新输入");
          this.$playScanFailure();
          this.$refs.serialNumberInputs[index].focus();
          return false;
        }
        return true;
      },
      // 校验当前输入条码是否与已知第一条条码长度相同
      checkBarcodeLengthConsistency(currentBarcode, index) {
        const currentSerialNumber = this.scanList[0].serialNumber;
        this.barcodeLength = currentSerialNumber.length;
        if (currentBarcode.length !== this.barcodeLength) {
          this.$message.warning(`条码长度不一致，请重新输入。应为${this.barcodeLength}位。`);
          this.$playScanFailure();
          this.$refs.serialNumberInputs[index].focus();
          return false;
        }
        return true;
      },

      // 检查条码长度
      checkBarcodeLength() {
        //条码长度必须大于5或者小于35
        for (let i = 0; i < this.scanList.length; i++) {
          if (this.scanList[i].serialNumber !== "") {
            if (this.scanList[i].serialNumber.length < 5 || this.scanList[i].serialNumber.length > 35) {
              this.$message.warning("条码长度异常，请重新输入。");
              this.$refs.serialNumberInputs[i].focus();
              return;
            }
          }
        }
      },

      // 绑定条码
      bindBarcode() {
        if (!this.formData.billNo) {
          this.$message.warning("请输入生产订单号");
          return;
        }

        if (!this.formData.orderLength) {
          this.$message.warning("请先获取订单信息");
          return;
        }

        // 检查条码数量与工单数量是否一致
        // const filledBarcodes = this.scanList.filter(item => item.serialNumber.trim()).length;
        // if (filledBarcodes !== this.formData.orderLength) {
        //   this.$message.warning(`扫描的条码数量与工单数量不一致，请检查。工单数量: ${this.formData.orderLength}，已扫描数量: ${filledBarcodes}`);
        //   return;
        // }

        // 验证所有序列号是否都已输入
        // const emptySerialNumbers = this.scanList.filter(item => !item.serialNumber.trim());
        // if (emptySerialNumbers.length > 0) {
        //   this.$message.warning("请输入所有序列号");
        //   return;
        // }
        this.checkBarcodeLength();

        const snList = this.scanList.filter(item => item.serialNumber !== "").map(item => item.serialNumber.trim());
        const params = {
          orders: this.formData.billNo,
          snList: snList,
          type: this.formData.type,
          confirmFlag: this.formData.confirmFlag,
        };

        this.loading = true;
        // 这里需要替换为实际的绑定接口地址
        this.$http.post("basic", "sapProductionOrders/bingSnWithOrder", params)
          .then((res) => {
            this.loading = false;
            if (res.success) {
              this.$message.success("绑定成功");
              this.$playScanSuccess();
              // 设置绑定状态为true
              this.isBinded = true;
            }
          })
          .catch(error => {
            this.loading = false;
            console.error("绑定失败:", error);
            this.$playScanFailure();
          });
      },

      // 清空条码
      clearBarcode() {
        // 清空表单
        this.formData.billNo = "";
        this.formData.orderLength = "";
        this.formData.bindedLength = "";
        this.formData.leftLength = "";
        this.scanList = [];
        this.barcodeLength = null;
        this.isBinded = false;
        this.$message.success("已清空");
      },

      //导入
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData();
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http.post("basic", "sapProductionOrders/readPackTxt", formData).then((res) => {
          if (res.success) {
            this.importLoading = false;
            console.log(res.data);
            for (let i = 0; i < res.data.length; i++) {
              if (i <= this.scanList.length - 1) {
                const obj = this.scanList[i];
                console.log(obj);
                obj.serialNumber = res.data[i];
              } else {
                const item = {
                  index: i + 1,
                  serialNumber: res.data[i],
                };
                console.log(i, item);
                this.scanList.push(item);
              }
            }

            this.importLoading = false;
            this.$message.success("导入成功");
          } else {
            this.importLoading = false;
            this.$message.error(res.data);
          }
        }).catch((err) => {
          console.log(err);
          this.importLoading = false;
          this.$message.error("导入失败");
        });
      },

      // 导出文件
      exportFile() {
        if (this.scanList.length === 0 || !this.formData.billNo) {
          this.$message.error("请先扫描条码");
          return;
        }
        this.exportLoading = true;
        const scanList = this.scanList.filter(item => item.serialNumber !== "").map(item => item.serialNumber.trim());
        const queryList = scanList.map(item => ({
          orders: [this.formData.billNo],
          barcode: item,
        }));
        this.$http.postForFile("basic", "sapProductionOrders/exportPackList", queryList)
          .then(async(res) => {
            this.exportLoading = false;
            const blob = new Blob([res.data]);
            this.fallbackDownload(blob, this.exportFileName);
            this.$message.success("文件已下载");
          }).catch(() => {
            this.exportLoading = false;
          });
      },
      fallbackDownload(blob, fileName) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.download = fileName;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }
      },
    },
  };
</script>

<style scoped>
/* 保持简洁，使用默认样式即可 */
</style>